module.exports = __webpack_public_path__ + "img/lit_waatca.7d697111.png";